import { resource } from "./resource";

const api = resource("/policy-cateogary");

//common for trip and expense
export const getPolicyCategoryById = async (id) => await api.get(`/id/${id}`);

export const updatePolicyCategory = async (id, input = {}) => await api.put(`/${id}`, input);

//type="TRIP"
export const getAllVehicleType = async (legalUnit) =>
  await api.get(`/${legalUnit}`, { type: "TRIP" });

//type="ANY"
export const getAllExpenseCategory = async (legalUnit) =>
  await api.get(`/${legalUnit}`, { type: "ANY" });
